import { useEffect, useState } from "react";

import Category from "./Category";

function CategoriesMenu({ categoryList }) {
  const [categories, setCategories] = useState(categoryList || []);

  useEffect(() => {
    setCategories(categoryList);
  }, [categoryList]);

  return (
    <aside className="mb-[2rem] space-y-[1.75rem]">
      {categories?.map((category) => (
        <Category key={category.slug} categoryData={category} />
      ))}
    </aside>
  );
}

export default CategoriesMenu;
